import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => ({
  root: {},
  tabsIndicator: {
    backgroundColor: 'white',
    height: '100%',
    zIndex: 1,
    borderRadius: '4px 4px 0 0',
  },
  tabRoot: {
    color: '#818B9D',
    opacity: 1,
  },
  '&:focus': {
    color: '#192542',
  },
  '& span': {
    fontSize: 16,
  },
  label: {
    position: 'relative',
    zIndex: 2,
  },
  typography: {
    padding: theme.spacing(2) * 3,
  },
  buttonSave: {
    background: '#009358',
    color: '#fff',
    '&:hover': {
      background: '#036b41',
      color: '#fff',
    },
  },
  buttonCopy: {
    background: '#818B9D',
    color: '#fff',
    '&:hover': {
      background: '#192542',
      color: '#fff',
    },
  },
  tabContainer: {
    background: 'white',
    borderRadius: '0 4px 4px 0',
    padding: 24,
    boxShadow: '0 3px 2px 0 rgba(0,0,0,0.06), 0 5px 10px 0 rgba(0,0,0,0.02)',
    flex: 1,
  },
  input: {
    marginTop: 16,
    marginBottom: 16,
    position: 'relative',
  },
  bootstrapRoot: {
    padding: 0,
    ['label + &' as any]: {
      marginTop: theme.spacing(2) * 3,
    },
  },
  bootstrapInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  bootstrapFormLabel: {
    fontSize: 18,
  },
  fieldModified: {
    color: '#fabb0a',
    float: 'right',
    fontSize: 16,
    marginTop: '-30px',
  },
  variationWrapper: {
    display: 'flex',
    justifyItems: 'stretch',
  },
  variationTabs: {
    width: '80%',
    float: 'left',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 2,
  },
  variationMenu: {
    width: '20%',
    float: 'left',
    display: 'flex',
    justifyItems: 'stretch',
    flexDirection: 'column',
    flexGrow: 1,
    ['& > span' as any]: {
      height: 48,
      lineHeight: '48px',
      color: '#192542',
    },
  },
  variationList: {
    background: '#eee',
    boxShadow: '0 3px 2px 0 rgba(0,0,0,0.06), 0 5px 10px 0 rgba(0,0,0,0.02)',
    borderRadius: '4px 0 0 4px',
    flex: 1,
    overflow: 'hidden',
  },
  variationButton: {
    fontSize: 14,
    color: '#8E97A7',
    textAlign: 'left',
    borderRadius: 0,
    textTransform: 'none',
    fontWeight: 400,
    padding: '1rem 1.5rem',
    ['&.active' as any]: {
      color: '#192542',
      backgroundColor: 'rgba(0,0,0,0.1)',
    },
    '&:hover': {
      color: '#192542',
    },
  },
  infoReadyToSell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    fontSize: 13,
    color: theme.palette.primary.main,
    fontSmooth: 'antialiased',
    fontWeight: 700,
    '& svg': {
      fill: '#ffcd33',
    },
  },
  alert: {
    marginTop: 12
  }
}));
